import moment from "moment";
import { getBackendApiInstance, getInternalApiInstance } from "./base";

export interface CloneUserRequest {
  cloneEmail: string;
  sourceUserId: string;
}

export const getUserCheckInDetails = async (userId: string) => {
  const api = await getInternalApiInstance();
  const reqBody = { userId };
  try {
    const response = await api.post("/admin/checkin", { ...reqBody });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getUserWeightEma8Details = async (userId: string) => {
  const api = await getBackendApiInstance();
  const reqBody = { 
    userId,
    metric: "weight",
    valueType: "ema8",
    startDate: moment().subtract(60, "days")
        .startOf("day")
        .toISOString()
  };
  try {
    const response = await api.post("/admin/user-analytics", { ...reqBody });
    return response.data;
  } catch (error) {
    throw error;
  }
}
